type TCustomError = {
  isCustomError: boolean;
  status: number;
  bodyError?: any;
};

export const isCustomError = (obj: unknown): obj is TCustomError => {
  return typeof obj === "object" && obj !== null && "isCustomError" in obj && "status" in obj;
};
